module.exports = __webpack_public_path__ + "img/badge.8457fddd.svg";